export default __webpack_public_path__ + "assets/img/goto-webinar-lockup.e9074fee093b2ece2e4f73cd4132e2f7.svg";